import {
    bootstrap as sharedBootstrap,
    BootstrapOptions as SharedBootstrapOptions,
} from 'owa-shared-bootstrap';
// Import setHtmlLangOrchestrator so that it gets run.
import './orchestrators/setHtmlLangOrchestrator';
// Need to wait for flags before initializing themes
// since themes depend on flags.
import { waitForFlagsInitialization } from './orchestrators/waitForFlagsInitialization';
import 'owa-fabric-theme'; // Need to initialize orchestrators that listen for theme and locale change
import { DesktopErrorComponentAsync } from 'owa-desktop-error-component';
import { isOpx, getOpxHostApi } from 'owa-opx';
import { getWindowTitle } from './initialization/getWindowTitle';
import { initializeOwaLocalization } from './initialization/initializeOwaLocalization';
import initializeTheme from './initialization/initializeTheme';
import { getBposPromise } from 'owa-bpos-store';

export interface BootstrapOptions
    extends Omit<
        SharedBootstrapOptions,
        'getWindowTitle' | 'initializeLocalization' | 'fullErrorComponent'
    > {
    getModuleName: () => string;
}

async function bootstrap({ getModuleName, ...options }: BootstrapOptions) {
    const prerenderPromises = (options.prerenderPromises || []).concat({
        promise: waitForFlagsInitialization
            .then(() => options.initializeThemePromise || Promise.resolve(false))
            .then((loadedTheme: boolean) =>
                loadedTheme ? null : options.initialConfig.sessionDataPromise
            )
            .then(sessionData =>
                sessionData ? initializeTheme(sessionData.owaUserConfig) : Promise.resolve()
            ),
        key: 'th',
    });
    const bposPromise = getBposPromise();
    if (bposPromise) {
        prerenderPromises.push({ promise: bposPromise, key: 'bpos' });
    }
    return sharedBootstrap({
        ...options,
        getWindowTitle: () => getWindowTitle(getModuleName),
        initializeLocalization: initializeOwaLocalization,
        fullErrorComponent: DesktopErrorComponentAsync,
        prerenderPromises,
        onComponentError: async () => {
            if (isOpx()) {
                (await getOpxHostApi()).onFatalError();
            }
        },
    });
}

export { bootstrap };
